const CURRENT_ORG_ID_KEY = 'CURRENT_ORG_ID';

export function getCurrentOrgId(): string | null {
  return localStorage.getItem(CURRENT_ORG_ID_KEY);
}

export function setCurrentOrgId(orgId: string): void {
  localStorage.setItem(CURRENT_ORG_ID_KEY, orgId);
}
